export const GIFTS_BY_RECIPIENT = 'Gifts For Them';
export const GIFTS_BY_RECIPIENT_FOR_TITLE = 'Gifts By Recipient';
export const GIFTS_BY_OCCASION = 'Gifts By Occasion';
export const GIFTS_BY_TYPE = 'Gifts By Type';
export const GIFTS_BY_INTEREST = 'Gifts By Interest';
export const GIFTS_BY_VALENTINES = "Valentine's Day Gifts";
export const VIEW_ALL_GIFTS = 'View All Gifts';
export const RECIPIENT = 'Recipient';
export const OCCASION = 'Occasion';
export const TYPE = 'Type';
export const INTEREST = 'Interest';
